"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marketing = exports.shadows = exports.breakpoints = exports.color = exports.code = exports.text = exports.subheading = exports.headers = exports.zIndex = exports.hoverEffect = exports.pageMargins = exports.pageMargin = exports.breakpoint = exports.typography = exports.spacing = exports.background = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _designSystem = require("@storybook/design-system");

var _theming = require("@storybook/theming");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var background = _designSystem.styles.background,
    spacing = _designSystem.styles.spacing,
    typography = _designSystem.styles.typography,
    breakpoint = _designSystem.styles.breakpoint,
    pageMargin = _designSystem.styles.pageMargin,
    pageMargins = _designSystem.styles.pageMargins,
    hoverEffect = _designSystem.styles.hoverEffect,
    zIndex = _designSystem.styles.zIndex,
    headers = _designSystem.styles.headers,
    subheading = _designSystem.styles.subheading,
    text = _designSystem.styles.text,
    code = _designSystem.styles.code;
exports.code = code;
exports.text = text;
exports.subheading = subheading;
exports.headers = headers;
exports.zIndex = zIndex;
exports.hoverEffect = hoverEffect;
exports.pageMargins = pageMargins;
exports.pageMargin = pageMargin;
exports.breakpoint = breakpoint;
exports.typography = typography;
exports.spacing = spacing;
exports.background = background;

var color = _objectSpread({
  midnight: '#171C23'
}, _designSystem.styles.color);

exports.color = color;
var breakpoints = [440, 600, 900, 1200];
exports.breakpoints = breakpoints;
var shadows = {
  tooltip: /*#__PURE__*/(0, _theming.css)("box-shadow:0px 0px 15px ", color.tr5, ",0px 1px 2px ", color.tr10, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:tooltip;"))
};
exports.shadows = shadows;
var marketing = {
  hero1: /*#__PURE__*/(0, _theming.css)({
    fontSize: 56,
    fontWeight: typography.weight.bold,
    lineHeight: '70px',
    letterSpacing: '-0.01em'
  }, process.env.NODE_ENV === "production" ? "" : ";label:hero1;"),
  hero2: /*#__PURE__*/(0, _theming.css)({
    fontSize: typography.size.l2,
    // 40
    fontWeight: typography.weight.bold,
    lineHeight: '48px',
    letterSpacing: '-0.01em'
  }, process.env.NODE_ENV === "production" ? "" : ";label:hero2;"),
  heading: /*#__PURE__*/(0, _theming.css)({
    fontSize: typography.size.l1,
    // 32
    fontWeight: typography.weight.bold,
    lineHeight: '40px',
    letterSpacing: '-0.01em'
  }, process.env.NODE_ENV === "production" ? "" : ";label:heading;"),
  subheading: /*#__PURE__*/(0, _theming.css)({
    fontSize: typography.size.m2,
    // 24
    fontWeight: typography.weight.bold,
    lineHeight: '32px'
  }, process.env.NODE_ENV === "production" ? "" : ";label:subheading;"),
  textLarge: /*#__PURE__*/(0, _theming.css)({
    fontSize: typography.size.s3,
    // 16
    fontWeight: typography.weight.regular,
    lineHeight: '28px'
  }, process.env.NODE_ENV === "production" ? "" : ";label:textLarge;"),
  textLargeBold: /*#__PURE__*/(0, _theming.css)({
    fontSize: typography.size.s3,
    // 16
    fontWeight: typography.weight.bold,
    lineHeight: '28px'
  }, process.env.NODE_ENV === "production" ? "" : ";label:textLargeBold;"),
  textSmall: /*#__PURE__*/(0, _theming.css)({
    fontSize: typography.size.s2,
    // 14
    fontWeight: typography.weight.regular,
    lineHeight: '20px'
  }, process.env.NODE_ENV === "production" ? "" : ";label:textSmall;")
};
exports.marketing = marketing;